import { Button, Row } from "antd";
import { ITemplate } from "../../types";
import { DownloadOutlined } from "@ant-design/icons";
import { useDownload } from "../../hooks/useDowload";
import { useCallback } from "react";

type DownloadSectionProps = {
  contractNumber: string;
  selectedItem: ITemplate;
};

export const DownloadSection = ({
  contractNumber,
  selectedItem,
}: DownloadSectionProps) => {
  const { isLoading, onDownload } = useDownload(contractNumber);

  const onDownloadClicked = useCallback(() => {
    onDownload(selectedItem.id, selectedItem.fileName);
  }, [onDownload, selectedItem]);

  return selectedItem.fileName ? (
    <Row className="d-block">
      {selectedItem.description && (
        <p className="mt-2 mb-0 text-md title">{selectedItem.description}</p>
      )}
      <Button
        disabled={isLoading}
        type="link"
        className="pa-0 text-md w-500"
        icon={<DownloadOutlined />}
        onClick={onDownloadClicked}
      >
        Download Form
      </Button>
    </Row>
  ) : (
    <Row>
      {selectedItem.description && (
        <p className="mt-2 mb-0 text-md title">{selectedItem.description}</p>
      )}
    </Row>
  );
};
